import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
                I'm an aspiring DevOps Engineer with a deep passion for software, 
                from development and automation to deployment and operations. My journey across 
                different technologies has led me to enjoy building robust, high-performance systems 
                that solve problems efficiently and provide the best possible experience for users.
              <br />
              <br />
              I’m proficient in
              <i>
                <b className="purple">
                  {" "}
                  Python, JavaScript, Django Framework, and Java{" "}
                </b>
              </i>
              — and I enjoy working on the deployment and infrastructure 
                side of software while also possessing a solid understanding 
                of both backend and frontend technologies.
              <br />
              <br />
              My key areas of interest includes
              <i>
                <b className="purple">
                  {" "}
                  cloud infrastructure, CI/CD pipelines, containerization, automation, and application deployment.                </b>
              </i>
                  I enjoy building scalable and reliable systems while continuously learning new 
                  technologies to deliver high-quality products and services.              
                <br />
              <br />
              Whenever possible, I love building projects with
              <b className="purple"> Python </b> and modern frameworks like{" "}
              <i>
                <b className="purple">React.js</b> and{" "}
                <b className="purple">Django Framework and Django RestFramework</b>.
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
